const trust = {
  transparency: {
    hero: {
      eyebrow: "પારદર્શિતા અને પ્રભાવ",
      title: "દરેક રૂપિયાનો હિસાબ, દરેક પરિણામનો અહેવાલ",
      subtitle:
        "દાતાઓનો વિશ્વાસ અમારી સૌથી મૂલ્યવાન મૂડી છે. અહીં તેનો પુરાવો છે.",
    },
    metrics: {
      donations: "વાર્ષિક પ્રક્રિયા થયેલ દાન",
      families: "દાતા પરિવારો",
      lives: "સીધી રીતે સહાય મળેલ જીવન",
      donorFunded: "દાતા-આધારિત · કોઈ ગ્રાન્ટ નહીં",
    },
    utilization: {
      eyebrow: "દાનનો ઉપયોગ",
      title: "દાન કરેલો દરેક રૂપિયો ક્યાં વપરાય છે",
      subtitle:
        "નાણાકીય વર્ષ 2025-26 માટેની ફાળવણી — સ્વતંત્ર ઓડિટ દ્વારા ચકાસાયેલ.",
      residentCare: "નિવાસી સંભાળ અને ભોજન",
      healthcare: "આરોગ્યસેવા અને દવાઓ",
      gaushala: "ગૌશાળા અને પશુ સંભાળ",
      gruhUdhyog: "ગૃહ ઉદ્યોગ અને આજીવિકા",
      operations: "સંચાલન અને અનુપાલન",
    },
    highlights: {
      eyebrow: "વાર્ષિક ઝલક",
      title: "તાજેતરના વર્ષોના સીમાચિહ્નો",
      y2026: {
        title: "ટ્રસ્ટ-વ્યાપી ડિજિટલ પ્લેટફોર્મ",
        body: "એકીકૃત એડમિન અને દાતા અનુભવ, માગ પ્રમાણે 80G રસીદો, રિયલ-ટાઇમ ઇમ્પેક્ટ ડેશબોર્ડ.",
      },
      y2025: {
        title: "નવી મેડિકલ વિંગનું ઉદ્ઘાટન",
        body: "ફિઝિયોથેરાપી અને ડેકેર યુનિટ સાથેનું 4-કેબિન ક્લિનિક, સંપૂર્ણપણે સમુદાયના દાતાઓ દ્વારા ભંડોળ પૂરું પાડવામાં આવ્યું.",
      },
      y2024: {
        title: "ટિફિન સેવાએ 1 લાખ ભોજનનો આંકડો વટાવ્યો",
        body: "મુંબઈભરમાં એકલા રહેતા વડીલોને દરરોજ ગરમ ભોજન પહોંચાડવામાં આવે છે.",
      },
      y2023: {
        title: "ગૌશાળા 40+ પશુઓ સુધી વિસ્તરી",
        body: "વિસ્તૃત આશ્રય, ઘાસચારા સંગ્રહ અને સ્થળ પર પશુ ચિકિત્સા કેબિન.",
      },
    },
    reports: {
      eyebrow: "અહેવાલો અને ફાઇલિંગ",
      title: "ખુલ્લા દસ્તાવેજો, મુક્તપણે ઉપલબ્ધ",
      subtitle:
        "નીચેના કોઈપણ અહેવાલની નકલ માટે, કૃપા કરીને અમારા સંપર્ક પાના દ્વારા સંપર્ક કરો.",
      request: "વિનંતી",
      annual: {
        title: "વાર્ષિક અહેવાલ 2025-26",
        note: "કાર્યક્રમો, નાણાં, ઓડિટ થયેલ નિવેદનો",
      },
      impact: {
        title: "ઇમ્પેક્ટ રિપોર્ટ 2025",
        note: "નિવાસી, આરોગ્યસેવા અને ગૌશાળાના પરિણામો",
      },
      form10b: {
        title: "ફોર્મ 10B (ઓડિટ)",
        note: "આવકવેરા વિભાગમાં ફાઇલ કરેલ",
      },
      certs: {
        title: "12A અને 80G પ્રમાણપત્રો",
        note: "કરમુક્તિ માન્યતા",
      },
    },
    achievements: {
      eyebrow: "ટ્રસ્ટની સિદ્ધિઓ",
      title: "માન્યતાઓ અને અનુપાલન",
      certified: {
        title: "12A અને 80G પ્રમાણિત",
        body: "આવકવેરા મુક્ત દરજ્જો. દાન 80G હેઠળ 50% કપાત માટે પાત્ર છે.",
      },
      samman: {
        title: "ગુજરાત સેવા સન્માન 2024",
        body: "સતત વડીલ સંભાળ સેવા માટે રાજ્ય ટ્રસ્ટ કાઉન્સિલ દ્વારા સન્માનિત.",
      },
      audit: {
        title: "100% ઓડિટ અનુપાલન",
        body: "સ્થાપનાથી દર વર્ષે સ્વતંત્ર રીતે ઓડિટ થાય છે. અહેવાલો વિનંતી પર ઉપલબ્ધ છે.",
      },
    },
    cta: {
      title: "વિશ્વાસ સાથે દાન આપો",
      subtitle:
        "દરેક દાનની સ્વીકૃતિ આપવામાં આવે છે, 80G હેઠળ રસીદ અપાય છે, અને અમારા પ્રકાશિત અહેવાલોમાં તેનો હિસાબ રાખવામાં આવે છે.",
      donate: "હમણાં દાન કરો",
      talk: "અમારી સાથે વાત કરો",
    },
  },
  trustees: {
    hero: {
      eyebrow: "નેતૃત્વ",
      title: "અમારા ટ્રસ્ટીઓ",
      subtitle: "Jivandhara ની દૃષ્ટિ અને મૂલ્યોના સંરક્ષકો.",
    },
    empty: "ટૂંક સમયમાં જાહેર કરવામાં આવશે.",
  },
  committee: {
    hero: {
      eyebrow: "અમારી ટીમ",
      title: "સમિતિના સભ્યો",
      subtitle: "અમારી રોજિંદી સેવાનું સંચાલન કરનારા લોકો.",
    },
    empty: "ટૂંક સમયમાં જાહેર કરવામાં આવશે.",
  },
};

export default trust;
